const GuestUserIcon = ({props}) => {
  return (
    <svg
      width="100mm"
      height="100mm"
      viewBox="0 0 100 100"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="profile-image"
      {...props}
    >
      <g>
        <path
          style={{
            fill: "#000000",
            fillOpacity: 0.164706,
            stroke: "none",
            strokeWidth: 1.33361,
            strokeLinejoin: "bevel",
            strokeMiterlimit: 8,
            paintOrder: "stroke markers fill"
          }}
          d="M 50.916603,14.985124 A 19.923256,20.492493 0 0 1 69.904009,36.356456 19.923256,20.492493 0 0 1 49.165559,55.930429 19.923256,20.492493 0 0 1 30.092546,34.639895 19.923256,20.492493 0 0 1 50.752265,14.978038"
        />
        <path
          style={{
            fill: "#000000",
            fillOpacity: 0.163227,
            stroke: "none",
            strokeWidth: 2.44785,
            strokeLinejoin: "bevel",
            strokeMiterlimit: 8,
            paintOrder: "stroke markers fill"
          }}
          d="M 51.68243,62.104846 A 36.569267,37.614105 0 0 1 86.53394,101.33207 36.569267,37.614105 0 0 1 48.468378,137.26022 36.569267,37.614105 0 0 1 13.459738,98.181309 36.569267,37.614105 0 0 1 51.380788,62.09184"
        />
      </g>
    </svg>
  );
}; 

export default GuestUserIcon;
